import React, { useContext, useState } from "react";
import { OptionSelector } from "./OptionSelector";
import StarekContext from "../context/StarekContext";

import moment from "moment";
import {
  getZones,
  getShifts,
  getDynamicShifts,
} from "../services/RepositoryService";
import { useEffect } from "react";

const now = moment();

const interval_options = [
  {
    label: "1 Week",
    value: 604800000,
  },
  {
    label: "24 Hrs (Full Day)",
    value: 86400000,
  },
  {
    label: "12 Hrs (Half Day)",
    value: 43200000,
  },
  {
    label: "8 Hrs (Shift Day)",
    value: 28800000,
  },
  {
    label: "4 Hrs (Half Shift)",
    value: 14400000,
  },
  {
    label: "1 Hr",
    value: 3600000,
  },
  {
    label: "30 Mins",
    value: 1800000,
  },
  {
    label: "10 Mins",
    value: 600000,
  },
];

const duration_options = [
  {
    label: "Last 10 Minutes",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-10, "minutes"),
    },
  },
  {
    label: "Last 30 Minutes",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-30, "minutes"),
    },
  },
  {
    label: "Last 4 Hours",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-4, "hours"),
    },
  },
  {
    label: "Last 8 Hours",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-8, "hours"),
    },
  },
  {
    label: "Last 12 Hours",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-12, "hours"),
    },
  },
  {
    label: "Last 24 Hours",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-24, "hours"),
    },
  },
  {
    label: "Last 1 Week",
    value: {
      offsetEnd: now,
      offsetStart: now.clone().add(-1, "week"),
    },
  },
];

function ReportFilter(props) {
  const starekContext = useContext(StarekContext);

  const [availableIntervals, setAvailableIntervals] = useState([
    interval_options,
  ]);

  const [dynamicShifts, setDynamicShifts] = useState([]);
  const [plannedShifts, setPlannedShifts] = useState([]);

  const [filterSelectionMessage, setFilterSelectionMessage] =
    useState("Nothing Selected!");

  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState();
  const [selectedInterval, setSelectedInterval] = useState();
  const [selectedShift, setSelectedShift] = useState();

  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [devices, setDevices] = useState([]);
  const [interval, setInterval] = useState(0);

  // const [duration, setDuration] = useState(0);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onFilterSetChanged = (data, parameter, fullData) => {
    if (parameter == "device") {
      setSelectedDevices(
        data.length > 0 ? data.length + " device selected" : ""
      );
    } else if (parameter == "duration") {
      setFrom(fullData.value.offsetStart);
      setTo(fullData.value.offsetEnd);
      //setSelectedDuration(fullData.label);
    } else if (parameter == "interval") {
      setSelectedInterval(fullData.value);
    } else if (parameter === "shift") {
      setSelectedShift(data);
      if (plannedShifts.findIndex((shift) => shift.value === data) >= 0) {
        setShowDatePicker(true);
      } else {
        setShowDatePicker(false);
      }
    } else if (parameter === "shift-date") {
      const date = new Date(data);
      const shiftStart = new Date(selectedShift.start);
      const shiftEnd = new Date(selectedShift.end);
      shiftStart.setDate(date.getDate());
      shiftStart.setMonth(date.getMonth());
      shiftStart.setYear(date.getFullYear());
      shiftEnd.setDate(date.getDate());
      shiftEnd.setMonth(date.getMonth());
      shiftEnd.setYear(date.getFullYear());
      setSelectedShift({
        start: shiftStart.toJSON(),
        end: shiftEnd.toJSON(),
      });
    } else if (parameter === "startTime") {
      //setSelectedDuration(data);
    }
  };

  useEffect(() => {
    const duration = to - from;
    if (duration > 0) {
      const ios = interval_options
        .filter((x) => x.value <= duration)
        .sort((a, b) => b.value - a.value);
      setAvailableIntervals(ios);
      if (ios[0]) {
        setSelectedInterval(ios[0]);
      }
    }
  }, [from, to]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const [shifts, dynamicShifts] = await Promise.all([
        getShifts(starekContext.lastUsedPlant.id),
        getDynamicShifts(starekContext.lastUsedPlant.id),
      ]);

      setPlannedShifts(
        shifts.map((shift) => ({
          label: shift.name,
          value: { start: shift.start_time, end: shift.end_time },
        }))
      );

      setDynamicShifts(
        dynamicShifts.map((shift) => ({
          start: shift.start_time,
          end: shift.end_time,
        }))
      );
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    setFilterSelectionMessage(
      `${selectedDevices?.length > 0 ? selectedDevices : ""} ${
        selectedDuration?.length > 0 ? selectedDuration + " in " : ""
      } ${selectedInterval?.length > 0 ? selectedInterval + " intervals" : ""}`
    );
  }, [from.to, interval, selectedDevices]);

  const deviceOptionSet = [
    {
      label: "Select Devices",
      key: "devices",
      attributes: [
        {
          parameter: "devices",
          type: "lookup",
          label: "Select Devices",
          options: [],
          leafPrefix: "device",
          maxItemsToCompact: 2,
          dataSource: async () => {
            const zones = await getZones(starekContext.lastUsedPlant.id, [
              "devices",
            ]);
            const rows = [];
            zones.map((z) => {
              rows.push(
                Object.assign(z, {
                  icon: "fa-bullseye",
                  __nodeId__: `zone#${z.id}`,
                  __parentNodeId__: z.parent_id ? `zone#${z.parent_id}` : null,
                })
              );
              z.devices.map((d) => {
                rows.push(
                  Object.assign(d, {
                    icon: "fa-microchip",
                    __nodeId__: `device#${d.id}`,
                    __parentNodeId__: `zone#${z.id}`,
                  })
                );
              });
            });
            return rows;
          },
        },
      ],
    },
  ];

  const durationOptionSet = [
    {
      label: "Shift",
      key: "by-shift",
      attributes: [
        {
          parameter: "shift",
          type: "select",
          isLoading: isLoading,
          options: [
            {
              label: "Dynamic Shifts",
              options: [
                {
                  label: "Last Completed Shift",
                  value: dynamicShifts[1] || {},
                },
                {
                  label: "Running Shift",
                  value: dynamicShifts[0] || {},
                },
              ],
            },
            {
              label: "Planned Shifts",
              options: plannedShifts,
            },
          ],
        },
        showDatePicker
          ? {
              parameter: "shift-date",
              label: "Shift Date",
              type: "singledate",
            }
          : {},
      ],
    },
    {
      label: "Duration",
      key: "by-duration",
      attributes: [
        {
          parameter: "duration",
          type: "select",
          options: duration_options,
        },
      ],
    },
    {
      label: "Custom",
      key: "custom",
      attributes: [
        {
          parameter: "startTime",
          label: "Start Date Time",
          type: "daterange",
        },
      ],
    },
  ];

  const intervalOptionSet = [
    {
      label: "Interval",
      key: "by-interval",
      attributes: [
        {
          parameter: "interval",
          type: "select",
          options: availableIntervals,
        },
      ],
    },
  ];
  return (
    <div className="card border shadow border-white collapsed-card">
      <div className="card-header border-0">
        <h6 className="card-title font-weight-bold text-primary">
          Report Filters
        </h6>
        <div className="card-tools">
          <span className="font-weight-bold text-primary text-sm">
            {filterSelectionMessage}
          </span>
          &nbsp; &nbsp;
          <button
            type="button"
            className="btn btn-primary btn-sm"
            data-card-widget="collapse"
            title="Collapse"
          >
            <i className="fas fa-plus"></i>
          </button>
        </div>
      </div>
      <div className="card-body">
        <div>
          <div>
            <div>
              <div className="container">
                <div className="row">
                  <OptionSelector
                    optionSet={deviceOptionSet}
                    optionsChanged={onFilterSetChanged}
                  ></OptionSelector>
                  <OptionSelector
                    optionSet={durationOptionSet}
                    optionsChanged={onFilterSetChanged}
                  ></OptionSelector>
                  <OptionSelector
                    optionSet={intervalOptionSet}
                    optionsChanged={onFilterSetChanged}
                  ></OptionSelector>
                </div>
              </div>

              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    {" "}
                    <button
                      className="btn btn-primary text-right"
                      onClick={async () => {
                        console.log("apply!");
                      }}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportFilter;
